
$( document ).ready(function() {
    console.log( "ready!" );
$('footer .footer__wrapper .footer__block p.h5,form #rich-text-01KGFM7ZTMBF0V165HP5PMWMTQ p,#shopify-section-template--20020837286067__image_with_text_custom_tA6YqE .key-point-item .key_content h4.h4').attr({'role':'heading','aria-level':'2'});
$('.announcement-bar__wrapper #announcement-bar').attr({'aria-live':'polite','aria-atomic':'true'});
$('.shopify-section-group-header-group .header__wrapper h1.header__logo,.header__secondary-nav nav.header__link-list ul.contents').attr('role','none');
$('.header__icon-list a[href="/search"]').attr('aria-label','Search');
$('.header__icon-list a[href="/search"],.header__icon-list a[href="/cart"]').attr({'role':'button','aria-expanded':'false'});
$('#shopify-section-sections--20020831617203__search-drawer #search-drawer').attr('aria-label','Search');
$('#shopify-section-template--20020837286067__image_with_text_custom_tA6YqE .image-with-text__key-points-wrapper .key-point-item img,#pi_base_section-template--20020837286067__freshcap_advantage_JtV6tQ .freshcap-advantage__wrapper .advantage_item img,#shopify-section-template--20020838596787__main .product-info-below-gallery .feature_icon_item .feature_icon img').attr('alt','');

$('#shopify-section-sections--20020831617203__cart-drawer #cart-drawer').attr('aria-label','Cart');
$('.place-self-start.text-custom .prose h2.pi-slideshow-top-heading').attr({'role':'heading','aria-level':'1'});
$('.anchor .shopify-policy__container .shopify-policy__body .rte.prose h1').attr({'role':'heading','aria-level':'2'});
const yotpoObserver = new MutationObserver(() => {
const $heading = $('p#yotpo-headline-reviews');
  if ($heading.length && !$heading.attr('role')) {
    $heading.attr({
      role: 'heading',
      'aria-level': '2'});}});
yotpoObserver.observe(document.body, {
  childList: true,
  subtree: true}); 

const capsuleBtnObserver = new MutationObserver(() => {
  const btn = $('.quick-buy-drawer--wrapper .pi-product-links a.button.button--xl');
  if (btn.length) {
    btn.text('Capsules');
    capsuleBtnObserver.disconnect();
  }
});
capsuleBtnObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// $('form #ContactForm-no,form #ContactForm-yes').attr('aria-labelledby','enquiry_id').removeAttr('aria-describedby');
setTimeout(()=>{
$('.shopify-policy__body h1').attr({'role':'heading','aria-level':'2'});
console.log('refund');
},4000);
$('.anchor .shopify-policy__container .shopify-policy__body .rte.prose h2').attr({'role':'heading','aria-level':'3'});
$('#cart-drawer .empty-state__icon-wrapper,#rich-text-01KGFM7ZVT0ME1PZPZ21E2X1HF p,#rich-text-01KGFM7ZW259TYTNN6G99R7HX0 p').attr('aria-hidden','true');
$('#shopify-section-template--20020837286067__scrolling_text_PWbWGJ .scrolling-text__text').attr('aria-hidden', 'true').first().attr('aria-hidden', 'false');
$('#shopify-section-template--20020837286067__scrolling_text_PWbWGJ .scrolling-text__text .marquee_text').attr('role','list');
$('#shopify-section-template--20020837286067__scrolling_text_PWbWGJ .scrolling-text__text .marquee_text .scrolling-item').attr('role','listitem');
$('#shopify-section-template--20020837286067__blog_posts_bEjJfW .blog-posts .blog-post-card a.blog-post-card__figure.rounded,#shopify-section-template--20020837286067__blog_posts_bEjJfW .blog-posts .blog-post-card .blog-post-card__info .v-stack p.h3 a').removeAttr('href');
$('#checkout-main button._1xqelvi1._1xqelvi0._1fragemur._1fragemsm._1xqelvi3._1fragem3c._1fragemth._1xqelvi8').attr('aria-label','More Info');
$(document).on('keydown', '.swiper--nav.swiper--prev,.swiper--nav.swiper--next', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    $(this).trigger('click');}});

  const $changeSubscriptionBtn = $(
    '.product-quick-add .product-sticky-bar__info .v-stack .variant-name .change-subscription');
  $changeSubscriptionBtn.attr({
    role: 'button',
    tabindex: '0'});
  $changeSubscriptionBtn.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');}});
function fixKlaviyoA11y() {
  const id1 = '#rich-text-01KGFM7ZVT0ME1PZPZ21E2X1HF';
  const id2 = '#rich-text-01KGFM7ZW259TYTNN6G99R7HX0';
  const $p1 = $(id1 + ' p').first();
  const $p2 = $(id2 + ' p').first();
  if ($p1.length) $p1.attr('aria-hidden', 'true');
  if ($p2.length) $p2.attr('aria-hidden', 'true');
  if ($p1.length && !$(id1 + ' .sr-only').length) {
    $p1.after(
      '<p class="sr-only" role="heading" aria-level="2">' +
      'Power Up Your Health Get 15% OFF' +
      '</p>');}}
fixKlaviyoA11y();
new MutationObserver(fixKlaviyoA11y)
  .observe(document.body, { childList: true, subtree: true });


document
  .querySelectorAll('.product-card .pointer-coarse button.button')
  .forEach((btn) => {
    const mainSearchBusyObserver = new MutationObserver(() => {
      btn.removeAttribute('aria-busy');
    });
    mainSearchBusyObserver.observe(btn, {
      attributes: true
    });});

const searchBtn = document.querySelector('form.main-search-form button.button');
if (searchBtn) {
  new MutationObserver(() => searchBtn.removeAttribute('aria-busy'))
    .observe(searchBtn, { attributes: true, attributeFilter: ['aria-busy'] });}

$('.blog-post-card').each(function () {
  const title = $(this).find('.h3 a').text().trim();
  const $readMore = $(this).find('.read_more_link');
  if (!$readMore.length || !title) return;
  $readMore.attr('aria-label', 'Read more about ' + title);
});
 
  setTimeout(function(){
    $('.fancybox__slide video.reel_poster img').attr('alt','');
  },300);


new MutationObserver(() =>
  $('.product-info__quantity-selector button:has(svg.icon-minus)').attr({'aria-disabled':'true','disabled':'disabled'})
).observe(document.body,{childList:true,subtree:true});
$('body #shopify-section-template--20020837482675__contact .section-stack__intro p.subheading').attr({'role':'heading','aria-level':'1'});
$('.pi_base_section.pi-freshcap-advantage .freshcap-advantage__wrapper').attr('role','list');
$('.pi_base_section.pi-freshcap-advantage .freshcap-advantage__wrapper .freshcap-advantage__list .advantage_item').attr('role','listitem');
$('#shopify-section-template--20020837286067__collection_list_EmQYNG .collection-card__content .collection_tag span')
  .each(function () {
    const $span = $(this);
    $span.replaceWith(
      $('<div>', {
        class: $span.attr('class'),
        html: $span.html()}));});

if (!document.getElementById('cart-live-region')) {
  $('body').append(
    '<div id="cart-live-region" aria-live="polite" aria-atomic="true" style="position:absolute;left:-9999px;"></div>');}
$(document).on('click', '.line-item .plus, .line-item .minus', function () {
  const $item = $(this).closest('.line-item');
  const title = $item.find('.product_title').text().trim();
  $('#cart-live-region').text('Loading');
  setTimeout(() => {
    const qty = $item.find('.quantity-input').val();
    $('#cart-live-region').text(
      'Changed quantity of ' + title + ' to ' + qty
    );}, 800);});

// 
// document.querySelectorAll('.line-item').forEach(item => {
//   const qtyInput = item.querySelector('.quantity-input');
//   const title = item.querySelector('.product_title').textContent.trim();

//   qtyInput.setAttribute('aria-label', `Quantity for ${title}, currently ${qtyInput.value}`);

//   qtyInput.addEventListener('input', () => {
//     qtyInput.setAttribute('aria-label', `Quantity for ${title}, currently ${qtyInput.value}`);
//   });
// });
// document.querySelectorAll('.line-item').forEach(item => {
//   const qtyInput = item.querySelector('.quantity-input');
//   const title = item.querySelector('.product_title').textContent.trim();

//   qtyInput.addEventListener('input', () => {
//     const qty = qtyInput.value;
//     qtyInput.setAttribute('aria-label', `Change quantity of ${title}, currently ${qty}`);
//   });
// });
// 


$('#shopify-section-template--20020838596787__main .video-reels-lists .video-reel-item a').attr('role','button');

const searchInput = document.querySelector('#search-drawer input[type="search"]');
const liveRegion = document.getElementById('search-live-region');
if (searchInput && liveRegion) {
  searchInput.addEventListener("input", function () {
    if (searchInput.value.length > 0) {
      liveRegion.textContent = "Loading search results";
    }});}
const predictiveSearch = document.querySelector("predictive-search");
if (predictiveSearch && liveRegion) {
  const observer = new MutationObserver(() => {
    const results = predictiveSearch.querySelectorAll(".predictive-search-result");
    if (results.length > 0) {
      if (results.length === 1) {
        liveRegion.textContent = "1 result found";
      } else {
        liveRegion.textContent = results.length + " results found in total";
      }}});
  observer.observe(predictiveSearch, {
    childList: true,
    subtree: true
  });}

function fixThumbnailGroup() {
  const $group = $('.pwzrjss2 .PwzrGrid-container').first();
  $group.attr({
    role: 'group',
    'aria-label': 'Product thumbnails'
  });
  const $items = $group.find('.pwzrjss5[role="button"]');
  const total = $items.length;
  $items.each(function (i) {
    $(this).attr({
      'aria-posinset': i + 1,
      'aria-setsize': total,
      // 'aria-label': 'Thumbnail ' + (i + 1) + ' of ' + total
    });});}
fixThumbnailGroup();
new MutationObserver(fixThumbnailGroup).observe(document.body, {
  childList: true,
  subtree: true});
$('.v-stack.product_info_bottom .pi-product-links .button--outline.active').attr('aria-current','page');
$('.pi-product-links.h-stack.wrap.gap-2').each(function () {
  const $div = $(this);
  if ($div.data('converted')) return;
  const $ul = $('<ul>', {
    class: $div.attr('class')});
  $div.find('a.button--outline').each(function () {
    $('<li>').append($(this)).appendTo($ul);});
  $div.replaceWith($ul);
  $ul.data('converted', true);});
$('.product .product-info-below-gallery .product_feature_icons').attr('role','list');
$('.product .product-info-below-gallery .product_feature_icons .feature_icon_item').attr('role','listitem');
new MutationObserver(() => {
  $('form[data-skio-name="login-email-form"] p[data-skio-name="login-email-error"], form#Form0 p#error-for-customer-authentication-web-email')
    .attr('role', 'alert');
}).observe(document.body, { childList: true, subtree: true });

setTimeout(()=>{
$('.product-info .video-reels-lists a .video-reel-thumb img,.freshcap-advantage__wrapper .freshcap-advantage__list .icon img,.image-with-text__key-points-wrapper.a11y_img  .key_icon img').attr('alt','');
},800)
new MutationObserver(() => {
  $('#subscription-policy-policy-modal [tabindex]').removeAttr('tabindex');
}).observe(document.body, { childList: true, subtree: true });
new MutationObserver(() => {
  $('.yotpo-paragraph-summary-container button.yotpo-reviews-summary-button')
    .removeAttr('aria-label');
}).observe(document.body, { childList: true, subtree: true });
new MutationObserver(() => {
  $('.PwzrIconButton-root').each(function () {
    const $btn = $(this);
    const path = $btn.find('svg path').attr('d') || '';
    if (path.includes('7.41 15.41') || path.includes('up')) {
      $btn.attr('aria-label', 'Scroll thumbnail up');
    } else {
      $btn.attr('aria-label', 'Scroll thumbnail down');
    }});
}).observe(document.body, { childList: true, subtree: true });
$('.product-card__mobile-quick-buy-button, .pi-product-card__quick-buy .pointer-coarse .button').attr('aria-expanded','false');
function updateATCLabels() {
  $('.shopify-section--product-recommendations .product-card,#pi_base_section-template--20020837286067__pi_featured_collection_top_tabs_7LcmnC .product-card').each(function () {
    const $card = $(this);
    const productName = $card
      .find('.product-card__title a')
      .text()
      .trim();
    const price = $card
      .find('.price-list sale-price')
      .clone()
      .find('.sr-only').remove().end()
      .text()
      .replace(/\s+/g,' ')
      .trim()
      .split(' ')[0];
    const dis_price = $card
      .find('.price-list compare-at-price')
      .clone()
      .find('.sr-only').remove().end()
      .text()
      .replace(/\s+/g,' ')
      .trim()
      .split(' ')[0];
    if (!productName) return;
    // const label = price
    //   ? 'Add to cart - Sale price ' + price + ' - discounted price ' + dis_price + ' - ' + productName
    //   : 'Add to cart - ' + productName;
    const label = price
  ? 'Add to cart - Sale price ' + price + 
    (dis_price ? ' - discounted price ' + dis_price : '') + 
    ' - ' + productName
  : 'Add to cart - ' + productName;
    $card
      .find('.product-card__mobile-quick-buy-button, .pi-product-card__quick-buy .button')
      .attr('aria-label', label);
});}
updateATCLabels();

const recObserver = new MutationObserver(updateATCLabels);
recObserver.observe(document.body, {
  childList: true,
  subtree: true});

const $tabList = $('.pi-top-tab-label-container');
  const $tabs = $tabList.find('.pi-tab-label');
  $tabList.attr('role', 'tablist');
  $tabs.each(function () {
    const $tab = $(this);
    $tab.attr('role', 'tab');
    if ($tab.attr('aria-hidden') === 'false') {
      $tab.attr({
        tabindex: '0',
        'aria-selected': 'true'});
    } else {
      $tab.attr({
        tabindex: '-1',
        'aria-selected': 'false'
      });}});
  $tabs.on('keydown', function (e) {
    const $current = $(this);
    let index = $tabs.index(this);
    let newIndex = index;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      newIndex = (index + 1) % $tabs.length;}
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      newIndex = (index - 1 + $tabs.length) % $tabs.length;}
    if (newIndex !== index) {
      e.preventDefault();
      const $newTab = $tabs.eq(newIndex);
      $tabs.attr('tabindex', '-1');
      $newTab.attr('tabindex', '0').focus();}
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $current.trigger('click');}});
  $tabs.on('click', function () {
    const $clicked = $(this);
    $tabs.attr({
      'aria-selected': 'false',
      tabindex: '-1'});
    $clicked.attr({
      'aria-selected': 'true',
      tabindex: '0'
    }).focus();}); 
const yotpoStarObserver = new MutationObserver(() => {
  $('.yotpo-review-star-rating').attr('tabindex', '0');});
yotpoStarObserver.observe(document.body, {
  childList: true,
  subtree: true});
$('#announcement-bar span.offer_drawer_opener').attr({'role':'button','tabindex':'0'});
$('.page-spacer .prose iframe').attr('title','Man speaking about a newly launched e book related to Mushrooms');

$('.a11y_custommenubtn').on('keydown', function(e) {
	  if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
		e.preventDefault();
		$(this).click();
	  }
});


$(document).on('click', '.skip-to-content', function (e) {
  const $target = $('#main');
  if ($target.length) {
    e.preventDefault();
    if (!$target.is('[tabindex]')) {
      $target.attr('tabindex', '-1');}
    $target.focus();}});
function applyQtyLabels() {
  $('.cart-drawer__products .line-item').each(function () {
    const title = $(this).find('.product_title').text().trim();
    if (!title) return;
    $(this).find('.plus')
      .attr('aria-label', 'Increase Quantity of ' + title);
    $(this).find('.minus')
      .attr('aria-label', 'Decrease Quantity of ' + title);
    $(this).find('.quantity-input')
      .attr('aria-label', 'Change quantity of ' + title);
    $(this).find('.line-item__actions span.text-xs a')
  .attr({
    role: 'button',
    'aria-label': 'Delete product ' + title});});}
applyQtyLabels();
new MutationObserver(applyQtyLabels).observe(document.body, {
  childList: true,
  subtree: true});
function applyPriceLabels() {
  $('.line_item_price').each(function () {
    const sale = $(this).find('.sale_price').text().trim();
    const regular = $(this).find('.compare_price').text().trim();
    if (sale) {
      $(this).find('.sale_price')
        .attr('aria-label', 'Discounted Price ' + sale);}
    if (regular) {
      $(this).find('.compare_price')
        .attr('aria-label', 'Regular Price ' + regular);
    }});}
applyPriceLabels();
new MutationObserver(applyPriceLabels).observe(document.body, {
  childList: true,
  subtree: true});

function applyPdpQtyLabel() {
  const title = $('.product-info__title').text().trim();
  if (!title) return;
  $('.quantity-selector__input').attr(
    'aria-label',
    'Change quantity of ' + title);}
applyPdpQtyLabel();
new MutationObserver(applyPdpQtyLabel).observe(document.body, {
  childList: true,
  subtree: true});

function fixSkioUpgradeLabels() {
  $('.line-item').each(function () {
    const title = $(this).find('.product_title').text().trim();
    if (!title) return;
    const skioEl = this.querySelector('skio-cart-upsell, skio-plan-picker');
    if (!skioEl || !skioEl.shadowRoot) return;
    const btn = skioEl.shadowRoot.querySelector('.skio-cart-upgrade');
    if (!btn) return;
    btn.setAttribute(
      'aria-label',
      'Upgrade to subscription for ' + title);});}
fixSkioUpgradeLabels();
new MutationObserver(fixSkioUpgradeLabels).observe(document.body, {
  childList: true,
  subtree: true});

$('footer .footer__logo svg').attr({'role':'img','aria-label':'Freshcap logo'});
$('img[src*="01HZM17TJP1MBMY9N60T3Y9VYV"]').attr('alt', 'Freshcap logo');
$('img[src*="DTC_Main_Banner_5035ad9a-6f87-4c49-b059-16d6811e7fa4.webp"]').attr('alt', '');
$('.rio-media-gallery .PwzrGrid-root .pwzrjss5').removeAttr('aria-label');

$('form#footer-newsletter').on('submit', function () {
  const $banner = $('form#footer-newsletter .banner');
  $banner.attr({
    role: 'alert',
    'aria-live': 'assertive'});
  setTimeout(() => {
    this.submit();
  }, 500);
  return false;});
$('.cart_inner__main .cart-drawer__products .line-item__info div a.product_title')
  .not(function(){ return $(this).parent().is('h3'); })
  .wrap('<h3></h3>');
$('.mega-menu .mega-menu__nav .v-stack a .h6.sub_menu_item.reversed-link')
  .not(function(){ return $(this).parent().is('h2'); })
  .wrap('<h2></h2>');
function updateCartLabel() {
    const $wrap = $('.header__icon-list');
    const count = $wrap.find('cart-count').text().trim() || '0';
    const label = count === '1'
      ? 'Cart, 1 item added'
      : 'Cart, ' + count + ' items added';
    $wrap.find('a[aria-controls="cart-drawer"]').attr('aria-label', label);}
  updateCartLabel();
  const target = document.querySelector('.header__icon-list cart-count');
  if (target) {
    new MutationObserver(updateCartLabel)
      .observe(target, { childList: true, subtree: true });}

  $('.rte.prose p span').each(function () {
    const text = $(this).text().trim();
    const match = text.match(/^(\d+)\./);
    if (match) {
      $(this).attr({
        role: "heading",
        "aria-level": "2"
      });
    }
  });

  $('.product-info__variant-picker.product_info_bottom').each(function () {
    var legendText = $(this).find('legend').first().text().trim().replace(':','');
    $(this).attr({
        role: 'group',
        'aria-label': legendText
    });
  });

  $('.play_video').on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
    }
  });
// 
const observer_expand = new MutationObserver(() => {
  document.querySelectorAll(".pi-product-card__quick-buy button.button")
    .forEach(btn => btn.removeAttribute("aria-expanded"));
});
observer_expand.observe(document.body, {
  childList: true,
  subtree: true
});
// $('.buy-buttons .block-label.hidden').attr('aria-label','Quantity');
// menu trap
window.a11y = window.a11y || {};

  let lastFocusedElement = null;
  let cleanupFn = null;

  window.a11y.trapFocus = function trapFocus(container) {
    function handleKeyDown(event) {
      if (!container.contains(document.activeElement)) return;

      const focusableSelector = [
        "a[href]:not([tabindex='-1'])",
        "area[href]:not([tabindex='-1'])",
        "input:not([disabled]):not([tabindex='-1'])",
        "select:not([disabled]):not([tabindex='-1'])",
        "textarea:not([disabled]):not([tabindex='-1'])",
        "button:not([disabled]):not([tabindex='-1'])",
        "iframe:not([tabindex='-1'])",
        "[tabindex]:not([tabindex='-1'])",
        "[contentEditable=true]:not([tabindex='-1'])"
      ].join(",");

      const focusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter((el) => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return (
          el.offsetParent !== null &&
          style.visibility !== "hidden" &&
          style.display !== "none" &&
          rect.width > 0 &&
          rect.height > 0 &&
          !el.hasAttribute("hidden")
        );
      });

      if (!focusableElements.length) return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  };

  window.a11y.setupModalFocus = function (triggerSelector, modalSelector, closeSelector) {
    $(document).on('click keydown', triggerSelector, function (e) {
      if (e.type === 'click' || e.key === "Enter" || e.keyCode === 13) {
        lastFocusedElement = this;
        console.log('lastFocusedElement', lastFocusedElement);

        if (e.type === 'keydown') {
          $(this).trigger('click');
        }

        setTimeout(() => {
          const $modal = $(modalSelector);
          if (!$modal.length) return;

          const $firstFocusable = $modal.find(
            'input, button, a, [tabindex]:not([tabindex="-1"])'
          ).filter(':visible').first();

          $firstFocusable.focus();

          if (typeof cleanupFn === 'function') cleanupFn();
          cleanupFn = window.a11y.trapFocus($modal[0]);
        }, 500);
      }
    });

    $(document).on('click keydown', closeSelector, function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
        if (typeof cleanupFn === 'function') {
          cleanupFn();
          cleanupFn = null;
        }

        setTimeout(() => {
          if (lastFocusedElement) {
            $(lastFocusedElement)
              .trigger('focus')
              .trigger('mousedown');
            lastFocusedElement = null;
          }
        }, 100);
      }
    });
  };

window.a11y.setupModalFocus(
    '.offer_drawer_opener',
    '#offers-drawer',
    '.offer_drawer_opener'
  );

window.a11y.setupModalFocus(
    'a[aria-controls="search-drawer"]',
    '#search-drawer',
    'a[aria-controls="search-drawer"]'
  );

window.a11y.setupModalFocus(
    'a[aria-controls="cart-drawer"]',
    '#cart-drawer',
    'a[aria-controls="cart-drawer"]'
  );

window.a11y.setupModalFocus(
    'product-list button.button',
    '.a11y_trap',
    'product-list button.button'
  );

window.a11y.setupModalFocus(
    '.pi-navigation-panel__menu button[aria-expanded]',
    '.pi-panel-level-2',
    '.pi-navigation-panel__menu button[aria-expanded]'
  );

// window.a11y.setupModalFocus(
//     'button.account-dropdown',
//     '.dropdown-content.show',
//     'button.account-dropdown'
//   );
new MutationObserver(() => {
    const btn = document.querySelector('#contact-form-template--20020837482675__contact button');
    if (btn && btn.hasAttribute('aria-busy')) {
        btn.removeAttribute('aria-busy');
        console.log('aria-busy removed!');
    }
}).observe(document.body, { childList: true, subtree: true });

// Focus trap for account dropdown
const accountBtn = document.querySelector('button.account-dropdown');
if (accountBtn) {
accountBtn.addEventListener('click', () => {
  const dropdown = accountBtn.querySelector('.dropdown-content');
  if (dropdown) {
    dropdown.style.display = 'block'; 
    dropdown.style.opacity = '1';
    dropdown.style.pointerEvents = 'auto';
    setTimeout(() => {
      const firstLink = dropdown.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
      if (firstLink) {
        firstLink.focus({ preventScroll: true });
      }
    }, 50);
  }
});
}
});

let lastState = null;

function checkMenuState() {
  const drawer = document.querySelector('navigation-drawer');
  if (!drawer) return;

  const isOpen = drawer.hasAttribute('open');

  if (isOpen === lastState) return;

  lastState = isOpen;

  const content = Array.from(document.body.children).filter(el =>
    !el.matches('.shopify-section--header, navigation-drawer')
  );

  if (isOpen) {
    content.forEach(el => el.setAttribute('aria-hidden', 'true'));

    document.querySelectorAll('.header__secondary-nav, .header__logo')
      .forEach(el => el.setAttribute('aria-hidden', 'true'));

    console.log('menu opened');

  } else {
    content.forEach(el => el.removeAttribute('aria-hidden'));

    document.querySelectorAll('.header__secondary-nav, .header__logo')
      .forEach(el => el.removeAttribute('aria-hidden'));

    console.log('menu closed');
  }
}
requestAnimationFrame(function loop() {
  checkMenuState();
  requestAnimationFrame(loop);
});